const cart = {
  hu: {
    Accessories: "Kiegészítők",
    cart: "Kosár",
    "Shipping and payment": "Szállítás és fizetés",
    "Delivery data": "Szállítási adatok",
    Summary: "Összefoglalás",
    Color: "Szín",
    OPTIONAL: "OPCIONÁLIS",
    Subtotal: "Részösszeg",
    Total: "Végösszeg",
    "Go to product": "Vissza a szerkesztőhöz",
    Shipping: "Szállítás",
    Payment: "Fizetés",
    "Do you need advice": "Segítségre van szükséged",
    "We are here for you":
      "Hétfőtől péntekig 08:00 és 17:00 óra között állunk rendelkezésre.",
    "Mon-Fri": "",
    Products: "Termékek",
    "Short summary": "Áttekintés",
    "First name": "Keresztnév",
    "Last name": "Vezetéknév",
    Address: "Cím",
    Number: "Szám",
    "Phone number": "Telefonszám",
    City: "Város",
    Zip: "Irányítószám",
    Notes: "Megjegyzés",
    Summarization: "Összegzés",
    "Invoice data": "Számlázási adatok",
    "Must order": "Kötelező érvényű megrendelés",
    "Discount code": "Kedvezménykód",
    ADD: "Hozzáadás",
    Free: "Ingyenes",
    Size: "Méret",
    Cart: "Kosár",
    "Free delivery":
      "Vásároljon további <strong>{price}</strong> -ért és ingyenes kiszállítást kap",
    "Has free delivery": "<strong>Ingyenes szállítást kapsz!</strong>",

    discount_title: "Élvezze az 1+1 INGYENES akciót!",
    discount_text:
      "<strong>Az 1+1 INGYENES ÜVEGTÁBLA</strong> akció automatikusan aktiválódik a kosárban. Elég létrehozni két vagy több üvegtáblát bármilyen faállvánnyal és a <strong>kosárban eggyel kevesebb plakettet fizet!</strong>",

    "Change branch": "Válts ágat",
    "Choose branch": "Válassza ki a csomag felvevó helyet",
  },
  sk: {
    sold_capacity_title: "Výrobné kapacity sú naplnené",
    sold_capacity_text: "Nie je možné ďalej objednávať plakety.",
    "Mon-Fri": "PO-PIA 08:00 - 17:00",
    "Invoice data": "Fakturačné údaje",
    Services: "Dodatočné služby",
    "Must order": "Záväzne objednať",
    "Order summarization": "Sumarizácia objednávky",
    Summarization: "Sumarizácia",
    Notes: "Poznámky",
    "First name": "Meno",
    "Last name": "Priezvisko",
    Address: "Adresa",
    Number: "Číslo",
    City: "Mesto",
    Zip: "PSČ",
    Email: "Email",
    "Phone number": "Tel. číslo",
    "Short summary": "Priebežný sumár",
    Products: "Produkty",
    Free: "Zadarmo",
    Shipping: "Doprava",
    Payment: "Platba",
    "Do you need advice": "Potrebujete poradiť",
    "We are here for you": "Sme tu pre vás",
    Size: "Veľkosť",
    Theme: "Motív",
    Color: "Farba",
    Accessories: "Príslušenstvo",
    Cart: "Nákupný košík",
    "Discount coupon": "Zľavový kupón",
    "Discount code": "Zľavový kód:",
    Total: "Celkom",
    Subtotal: "Medzisúčet",
    "Shipping and payment": "Doprava a platba",
    "Go to product": "Späť do editoru",
    "Remove from cart": "Odstrániť z košíka",
    "Edit product": "Upraviť produkt",
    RECOMMENDED: "ODPORÚČAME",
    ADD: "PRIDAŤ",
    empty_cart: "Ľutujeme, Váš košík je prázdny :-(",
    go_to_products: "Prejsť do zoznamu produktov",
    cart: "Košík",
    "Delivery data": "Dodacie údaje",
    Summary: "Súhrn",
    OPTIONAL: "VOLITEĽNÉ",
    "Back to cart": "Späť do košíka",
    "Change branch": "Zmeniť pobočku",
    "Choose branch": "Vybrať pobočku",
    "Free delivery":
      "Pre <strong>dopravu zadarmo</strong> nakúpte ešte za <strong>{price}</strong> !",
    "Has free delivery": "<strong>Dopravu máte zadarmo!</strong>",
    // validation
    required_field: "Pole {name} je povinné",

    discount_title: "Užite si -30% zľavu! ❤️",
    discount_text:
      "Vážený zákazníci, s kódom <strong>DARCEK</strong> získate <strong>-30% zľavu na celú objednávku!</strong> Zľavový kód <strong>DARCEK</strong> aktivujete v prvom kroku košíka 🎁.",
  },
  cs: {
    sold_capacity_title: "Výrobní kapacity jsou naplněny",
    sold_capacity_text: "Nelze dále objednávat plakety.",
    "Mon-Fri": "PO-PÁT 08:00 - 17:00",

    "Invoice data": "Fakturační údaje",
    Services: "Dodatečné služby",
    "Must order": "Závazně objednat",
    "Order summarization": "Sumarizace objednávky",
    Summarization: "Sumarizace",
    Notes: "Poznámky",
    "First name": "Jméno",
    "Last name": "Příjmení",
    Address: "Adresa",
    Number: "Číslo",
    City: "Město",
    Zip: "PSČ",
    Email: "Email",
    "Phone number": "Tel. číslo",
    "Short summary": "Průběžný sumář",
    Products: "Produkty",
    Free: "Zdarma",
    Shipping: "Doprava",
    Payment: "Platba",
    "Do you need advice": "Potřebujete poradit",
    "We are here for you": "Jsme tady pro vás",
    Size: "Velikost",
    Theme: "Motiv",
    Color: "Barva",
    Accessories: "Příslušenství",
    Cart: "Nákupní košík",
    "Discount coupon": "Slevový kupón",
    "Discount code": "Slevový kód:",
    Total: "Celkem",
    Subtotal: "Medzisoučet",
    "Shipping and payment": "Doprava a platba",
    "Go to product": "Zpět do editoru",
    "Remove from cart": "Odstranit z košíku",
    "Edit product": "Upravit produkt",
    RECOMMENDED: "DOPORUČUJEME",
    ADD: "PŘIDAT",
    empty_cart: "Litujeme, Váš košík je prázdný :-(",
    go_to_products: "Přejít do seznamu produktů",
    _cur: "Kč",
    cart: "Košík",
    "Delivery data": "Dodací údaje",
    Summary: "Souhrn",
    OPTIONAL: "VOLITELNÉ",
    "Back to cart": "Zpět do košíku",
    "Change branch": "Změnit pobočku",
    "Choose branch": "Vybrat pobočku",
    "Free delivery":
      "Pro <strong>dopravu zdarma</strong> nakupte ještě za <strong>{price}</strong> !",
    "Has free delivery": "<strong>Dopravu máte zdarma!</strong>",
    // validation
    required_field: "Pole {name} je povinné",

    discount_title: "Užijte si -30% slevu! ❤️",
    discount_text:
      "Vážení zákazníci, s kódem <strong>DAREK</strong> získáte <strong>-30% slevu</strong> na celou objednávku! Slevový kód <strong>DAREK</strong> aktivujete v prvním kroku košíku 🎁.",
  },
};

export default cart;
